/* eslint-disable camelcase, no-nested-ternary */
import { Component } from 'react';
import { Card, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BluBarAmbassadorObjective, Cancel } from '../../common/icons';
import { dateFormat } from '../../../utils/commonFunctions';
import { currentUserGroup } from '../../../utils/tokenUtils';

import './style.css';

class StockIt extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false
    };
  }

  toggleContent = () => {
    this.setState({ open: !this.state.open });
  };

  componentDidMount() {
    if (currentUserGroup() === 'staff') {
      this.setState({open: true});
    }
  }

  dateConvert = (dateString) => {
    const date = new Date(dateString);
    const parsed = Date.parse(date);
    return parsed;
  };

  checkEnded = () => {
    const { data } = this.props;
    const dateNow = Date.now();
    const checkDate = (this.dateConvert(data.end_date) < dateNow || dateNow < this.dateConvert(data.start_date));
    return checkDate;
  };

  render() {
    const { data } = this.props;
    const { open } = this.state;
    const target1 = `${data.total_products - data.target_1_products}/${data.total_products}`;
    const target2 = `${data.total_products - data.target_2_products}/${data.total_products}`;

    return (
      <div className="user-performance-container">
        <div className="incentive-performances">
          <Card className={open ? 'panel-open' : 'panel-closed'}>
            <Card.Header>
              <div onClick={this.toggleContent} className="performance-header-container card-title">
                <div className="performance-header-section performance-title-section">
                  <BluBarAmbassadorObjective height={24} width={24} className="performance-icon stock" />
                  <h2 className="performance-name">{`Blu Bar Ambassador Objective - ${data.name}`}</h2>
                  {data.locked && (
                    <OverlayTrigger
                      placement="left"
                      overlay={(
                        <Tooltip id="tooltip" className="tooltip">
                          This incentive is now closed and you can no longer earn points for selling these products.
                          Any points earned that have not yet been awarded will be awarded as soon as possible.
                        </Tooltip>
                      )}
                    >
                      <span className="glyphicon glyphicon-lock performance-lock" aria-hidden="true"></span>
                    </OverlayTrigger>
                  )}
                </div>
                <div className="performance-header-section">
                  <div className="maximum-points">
                    {open && (
                      data.end_date && this.checkEnded() ? (
                        <h2>Ended</h2>
                      ) : (
                        data.maximum_points && <h2>{`MAX POINTS ${data.maximum_points}`}</h2>
                      )
                    )}
                  </div>
                  <span className={`dropdown-arrow ${open && 'is-open'}`} />
                </div>
              </div>
            </Card.Header>
            {this.state.open && data && (
              <Card.Body>
                <div className="incentive-performance">
                  <div className="performance-details stockit-performance-details">
                    <div className="maximum-points mobile">
                      {open && (
                      data.end_date && this.checkEnded() ? (
                        <h2>Ended</h2>
                      ) : (
                        data.maximum_points && <h2>{`MAX POINTS ${data.maximum_points}`}</h2>
                      )
                    )}
                    </div>
                    {data.end_date && (
                    <div className="performance-details-dates">
                      <div className={ this.checkEnded() && 'ended'}>
                        {this.checkEnded() ? 'Ended' : 'Live until'} {dateFormat(data.end_date)}
                      </div>
                    </div>
                  )}
                    {data.description && (
                    <div className="performance-details-description">
                      {data.description}
                    </div>
                  )}
                    {(data.merchandising_standard && data.sell_out_qty) ? (
                      <div className="stockit-targets" style={{marginTop: '16px'}}>
                        1. STOCK {data.total_products - data.target_1_products} OF THE BELOW ON THE SHELF
                      </div>
                  ) : (
                    <div>
                      <div className="stockit-targets" style={{marginTop: '16px'}}>
                        KEEP {target1} OF THE BELOW AVAILABLE TO RECEIVE <span>{data.target_1_points}</span> IGNITE POINTS
                      </div>
                      {data.target_2_points && (
                      <div className="stockit-targets">
                        KEEP {target2} OF THE BELOW AVAILABLE TO RECEIVE AN EXTRA
                        <span>{data.target_2_additional_points}</span> IGNITE POINTS
                      </div>
                        )}
                    </div>
                    )}
                    <div className="performance-details-row-images">
                      {(data.product_images && data.product_images.length > 0) && (
                      data.product_images.map((value, key) => (
                        <div key={key} className="performance-details-row-images-container">
                          <img src={value} />
                        </div>
                      ))
                    )}
                    </div>
                    {data.merchandising_standard && data.sell_out_qty && (
                    <div className="stock-it-rules">
                      Must be on shelf when your Imperial rep visits.
                      Minimum of 2 Imperial rep visits required.
                      If you do not get a visit, please contact us via the Ignite app.
                    </div>
                  )}
                    {data.merchandising_standard && (
                    <div className="merchandising-standard">
                      <div className="separator"/>
                      <h2>2. Display in Store</h2>
                      {data.merchandising_standard}
                    </div>
                  )}
                    {data.sell_out_qty && (
                    <div className="sell_out_qty">
                      <div className="separator"/>
                      <h2>3. Sell Blu Bar 1000</h2>
                      {`Sell ${data.sell_out_qty} during incentive period - ${data.sell_out_qty_description}`}
                    </div>
                  )}
                  </div>
                  <div className="further-information">
                    <div className="further-information-body">
                      <div className="separator"/>
                      {(data.results && data.results.length > 0) && (
                      <h4 className="result-header">RESULT</h4>
                    )}
                      <div className="stockit-results-container">
                        {(data.results && data.results.length > 0) && (
                        data.results.map((result, key) => (
                          <div key={key} className="stockit-result">
                            {result.visit_count > 0 && (
                              <div className="result-total" style={{color: result.points === 0 && '#D51122'}}>
                                {result.products_stocked}/{data.total_products}
                              </div>
                            )}
                            {result.visit_count === 0 ? (
                              <div className="result-container" style={{backgroundColor: '#575756'}}>No Results</div>
                            ) : (
                              result.points > 0 ? (
                                <div
                                  className="result-container"
                                  style={{backgroundColor: '#5DBA5B', fontSize: '24px'}}
                                >
                                  {result.points}
                                </div>
                              ) : (
                                <div className="result-container" style={{backgroundColor: '#D51122'}}>
                                  <Cancel height={24} width={24}/>
                                </div>
                              )
                            )}
                            <div className="result-date">{dateFormat(result.start_date)}</div>
                            <div className="result-date">{dateFormat(result.end_date)}</div>
                          </div>
                        ))
                      )}
                      </div>
                      <div className="results-row">
                        <div className="results-total-points-container">
                          <h4 className="result-header">TOTAL POINTS</h4>
                          <div className="result-total-points">{data.total_points}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Card.Body>
            )}
          </Card>
        </div>
      </div>
    );
  }
}

export default StockIt;
